import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#8B5CF6", // Purple
      light: "#A78BFA",
      dark: "#7C3AED",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#EC4899", // Pink
      light: "#F472B6",
      dark: "#DB2777",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#10B981",
      light: "#34D399",
      dark: "#059669",
    },
    warning: {
      main: "#F59E0B",
      light: "#FBBF24",
      dark: "#D97706",
    },
    error: {
      main: "#EF4444",
      light: "#F87171",
      dark: "#DC2626",
    },
    info: {
      main: "#3B82F6",
      light: "#60A5FA",
      dark: "#2563EB",
    },
    background: {
      default: "#F9FAFB",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#111827",
      secondary: "#6B7280",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: "2.5rem",
    },
    h2: {
      fontWeight: 700,
      fontSize: "2rem",
    },
    h3: {
      fontWeight: 700,
      fontSize: "1.75rem",
    },
    h4: {
      fontWeight: 700,
      fontSize: "1.5rem",
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.25rem",
    },
    h6: {
      fontWeight: 600,
      fontSize: "1rem",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    "none",
    "0px 2px 4px rgba(0,0,0,0.05)",
    "0px 4px 6px rgba(0,0,0,0.07)",
    "0px 6px 10px rgba(0,0,0,0.08)",
    "0px 8px 14px rgba(0,0,0,0.09)",
    "0px 10px 18px rgba(0,0,0,0.1)",
    "0px 12px 22px rgba(0,0,0,0.11)",
    "0px 14px 26px rgba(0,0,0,0.12)",
    "0px 16px 30px rgba(0,0,0,0.13)",
    "0px 18px 34px rgba(0,0,0,0.14)",
    "0px 20px 38px rgba(0,0,0,0.15)",
    "0px 22px 42px rgba(0,0,0,0.16)",
    "0px 24px 46px rgba(0,0,0,0.17)",
    "0px 26px 50px rgba(0,0,0,0.18)",
    "0px 28px 54px rgba(0,0,0,0.19)",
    "0px 30px 58px rgba(0,0,0,0.2)",
    "0px 32px 62px rgba(0,0,0,0.21)",
    "0px 34px 66px rgba(0,0,0,0.22)",
    "0px 36px 70px rgba(0,0,0,0.23)",
    "0px 38px 74px rgba(0,0,0,0.24)",
    "0px 40px 78px rgba(0,0,0,0.25)",
    "0px 42px 82px rgba(0,0,0,0.26)",
    "0px 44px 86px rgba(0,0,0,0.27)",
    "0px 46px 90px rgba(0,0,0,0.28)",
    "0px 48px 94px rgba(0,0,0,0.29)",
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "8px 16px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
          },
        },
        contained: {
          "&:hover": {
            boxShadow: "0px 6px 12px rgba(0,0,0,0.15)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "&.Mui-selected": {
            fontWeight: 600,
          },
        },
      },
    },
  },
});
